import { motion } from "framer-motion";
import codingPerson from "../../Assets/lottie/codingPerson.json";
import DisplayLottie from "../../Components/DisplayLottie/DisplayLottie";
import ParticlesComponent from "../../Components/Particles/Particles";
import { heroOptions } from "../../Components/Particles/particlesOption";
import SectionTitle from "../../Components/SectionTitle/SectionTitle";
import { introduction } from "../../Constants/Constants.js";
import { fadeIn, staggerContainer } from "../../Constants/FramerMotions";
import "./about.scss";

const About = () => {
  return (
    <motion.div
      className="about-container"
      id="About"
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
    >
      {/* ABOUT LEFT SECTION */}
      <motion.div
        variants={fadeIn("left", "tween", 0, 0)}
        className="about-left"
      >
        <DisplayLottie animationData={codingPerson} />
      </motion.div>

      {/* ABOUT RIGHT SECTION */}
      <div className="about-right" style={{ zIndex: 1 }}>
        <motion.div
          variants={fadeIn("right", "tween", 0.1, 0.4)}
          style={{ width: "100%" }}
        >
          <SectionTitle title="About Me" subtitle="Introduction" />
        </motion.div>

        <div className="intro-text">
          <motion.span
            variants={fadeIn("left", "tween", 0.85, 0.4)}
            className="hello-there-word"
          >
            there
          </motion.span>
          <motion.span variants={fadeIn("right", "tween", 0.2, 0.4)}>
            Hello{" "}
            <motion.span
              variants={fadeIn("right", "tween", 0.2, 0.4)}
              style={{ textDecoration: "line-through" }}
            >
              world,
            </motion.span>
            👋 I'm so happy you are here :)
          </motion.span>
          <motion.span variants={fadeIn("right", "tween", 0.35, 0.4)}>
            {introduction?.text[1]}
          </motion.span>
          <motion.span variants={fadeIn("right", "tween", 0.45, 0.4)}>
            {introduction?.text[2]}
          </motion.span>
          <motion.span
            className="text-3-for-mobile"
            variants={fadeIn("right", "tween", 0.55, 0.4)}
          >
            {introduction?.text[3]}
          </motion.span>
        </div>
      </div>

      <ParticlesComponent
        particlesOptions={heroOptions}
        className="particles"
        id="custom_id"
      />
    </motion.div>
  );
};

export default About;
